<template>
  <div>
    <jd-form class="mb16" :form-info="formSchema" @search="search" ref="inputFormRef"/>
    <div style="margin-bottom: 16px" class="flex-between">
      <jd-button type="break" @click="addCrowd">按查询结果生成人群</jd-button>
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="dataSource"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: formList.total,
        }"
        @handlePage="handleCurrentChangeAll"
      >
        <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
        <el-table-column
          :prop="chaosParams"
          :label="`用户${grayText}`"
          width="150"
        ></el-table-column>
        <!-- 投放渠道 -->
        <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
        <el-table-column prop="createTime" label="参与时间"></el-table-column>
        <el-table-column prop="isPass" label="是否符合中奖条件">
          <template slot-scope="{ row }">
            <span>
              {{ row.isPass == 1 ? "符合" : row.isPass == 0 ? "不符合" : "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="buyMoney" label="订单金额">
          <template slot-scope="{ row }">
            <span>
              {{ row.buyMoney || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="itemTotal" label="商品件数">
          <template slot-scope="{ row }">
            <span>
              {{ row.itemTotal || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="measureUnitName" label="自定义计量单位">
          <template slot-scope="{ row }">
            <span>
              {{row.measureUnitCount || ""}}{{ row.measureUnitName || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单笔数">
          <template slot-scope="{ row }">
            <span>
              {{ row.orderCount || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="isWin" label="是否领取奖品">
          <template slot-scope="{ row }">
            <span>
              {{ row.isWin == 1 ? "已领取" : row.isWin == 0 ? "未领取" : "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="winTime" label="领奖时间">
          <template slot-scope="{ row }">
            <span>
              {{ row.winTime || "-" }}
            </span>
          </template>
        </el-table-column>
      </jd-table>
    </div>

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="formList"
      :activityType="rowData.activityType"
      :source="27"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import crowdDialog from "../crowd-Dialog.vue";
import {
  getJoinRecordList,
  exportAllInfo,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import statisticsData from "@/mixin/activity_statistics_new.js";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
  },
  props: {
    rowData: {
      type: Object,
      default: () => {},
    },
    currentShop: {
      // 当前选择店铺
      type: String,
      default: "",
    },
    sellerLinkList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formSchema: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "是否符合中奖条件：",
          prop: "isPass",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "符合", value: 1 },
            { label: "不符合", value: 0 },
          ],
        },
        {
          label: "是否领取奖品：",
          prop: "isWin",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "已领取", value: 1 },
            { label: "未领取", value: 0 },
          ],
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          // startTime: this.getDateStr(-30) + " 00:00:00",
          // endTime: this.getDateStr(0) + " 23:59:59",
          startTime: '',//进来默认时间但没传值，所以测试叫我去掉默认值
          endTime: '',
          startKey: "createStartTime",
          endKey: "createEndTime",
          defalutLimit: true,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          // startTime: this.getDateStr(-30) + " 00:00:00",
          // endTime: this.getDateStr(0) + " 23:59:59",
          startTime: '',
          endTime: '',
          startKey: "winStartTime",
          endKey: "winEndTime",
          defalutLimit: true,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: []
        },
      ],
      formList: {
        size: 10,
        current: 1,
        total: 0,
        activityId: this.rowData.id,
      },
      dataSource: [],
      loading: false,
      searchInfo: {}, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          const list = newVal.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.formSchema.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      },
      deep: true,
    },
    searchGrayId: {
      handler(newVal, oldVal) {
        this.formSchema.forEach((item)=>{
          if(item.prop=='pin') {
            item.label = item.label.replace(/pin/ig, newVal)
            item.prop = newVal;
            item.placeholder = item.placeholder.replace(/pin/ig, newVal)
          }
        })
      },
      immediate: true,
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrentChangeAll(val) {
      console.log(val);
      this.formList.size = val.pageSize
      this.formList.current = val.pageNum
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    search(params, type) {
      this.formList.current = 1;
      this.formList[this.searchGrayId] = params[this.searchGrayId] ? params[this.searchGrayId] : "";
      this.formList = {
        ...this.formList,
        ...params,
      };
      this.formList.sellerLinkId = params.sellerLinkId ? params.sellerLinkId : "";
      if (type == "reset") {
        this.searchInfo = {};
        this.formList.size = 10
        this.formList.current = 1
        this.getList();
        return;
      }
      this.searchInfo = params;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        const res = await getJoinRecordList(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.formList.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "满额有礼-参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(exportRemark = "") {
      let obj = this.$refs.inputFormRef.export_fun2();
      let params = {
        ...obj,
        activityId: this.rowData.id,
        current: 1,
        size: 9999999,
        exportRemark,
      };
      this.formLoading = true;
      exportAllInfo(params).then((res) => {
        this.formLoading = false;
      });
    },
    handleSizeChange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
